import React from 'react';
import './_footer.scss';

const Footer = () => {
    return (
        <>
        <section id="footer" className="footer-bg">
            <div className='wrapper txt-center'>
                <p>Copyright © 2023 Developed by <a href="https://www.linkedin.com/in/kciviletti/">KevinCiviletti</a></p>
            </div>    
        </section>   
        </>
    );
};

export default Footer;